import { BookingsService } from './../../core/services/bookings.service';
import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/core/models/user';
import { AuthService } from 'src/app/core/services/auth.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-client-list',
  templateUrl: './client-list.component.html',
  styleUrl: './client-list.component.scss'
})
export class ClientListComponent implements OnInit {

  students: User[] = [];
  constructor(private userService: UserService, private authService: AuthService, private bookingsService: BookingsService) {

  }

  ngOnInit(): void {
    this.authService.currentUser?.subscribe(user => {
      if (user) {
        const bookings = [];
        this.bookingsService.getUniqueInstructorBookings(user.userId).subscribe(data => {
          data.forEach(ele => {
            if (!bookings.find(el => el.studentId == ele.studentId)) {

              bookings.push(ele);
            }
          });
          console.log('Bookings ', bookings.length, ' ', bookings)
          for (var i = 0; i < bookings.length; i++) {
            const found = this.students.find(ele => bookings[i].studentId != ele.userId)
            if (!found) {
              this.userService.getUser(bookings[i].studentId).subscribe(user => {
                this.students.push(user);
                console.log(this.students)
              });
            }
          };

        });


      }
    });
  }

}
